import { gql } from "@apollo/client";

export const getEntityAuditLog = gql`
query($entity: String!, $entityId: String!){
  getEntityAuditLog(entity: $entity, entityId: $entityId) {
    message
    response
  }
}
`;